import ToolAccessTooltipBase from './components/tooltip/ToolAccessTooltipBase';
import withErrorBoundary from './hoc/withErrorBoundary';
import withToolAccess from './hoc/withToolAccess';

export default withErrorBoundary(withToolAccess(ToolAccessTooltipBase));
